"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var ConnectionStyles_1 = require("@/frontend/react/connections/ConnectionStyles");
var MessageContext_1 = __importDefault(require("../../context/MessageContext"));
var CurrentConnectionContext_1 = __importDefault(require("../../context/CurrentConnectionContext"));
var MessageList_1 = __importDefault(require("./MessageList"));
var SharedVacanciesList_1 = __importDefault(require("../shared_vacancies/SharedVacanciesList"));
var CurrentTab_1 = __importDefault(require("./CurrentTab"));
var NotificationContext_1 = __importDefault(require("../../context/NotificationContext"));
var useIsSmallScreen_1 = __importDefault(require("../../hooks/useIsSmallScreen"));
var defaultHeight = 50 + 56; // 50 topbar, 56 bottom textbox
function Chat() {
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var chatParam = (0, react_router_dom_1.useParams)().chatId;
    var _a = (0, react_1.useContext)(MessageContext_1.default), messages = _a.messages, setMessages = _a.setMessages, setCurrentConversationId = _a.setCurrentConversationId;
    var currentConnection = (0, react_1.useContext)(CurrentConnectionContext_1.default).currentConnection;
    var _b = (0, react_1.useContext)(NotificationContext_1.default), notifications = _b.notifications, clearNotification = _b.clearNotification;
    var topBarRef = (0, react_1.useRef)();
    var _c = (0, react_1.useState)(0), tab = _c[0], setTab = _c[1];
    var _d = (0, react_1.useState)(defaultHeight), height = _d[0], setHeight = _d[1];
    var _e = (0, react_query_1.useQuery)(['chat', chatParam], function () { return axios_1.default.get("/data/chats/".concat(chatParam)).then(function (result) { return result.data; }); }, {
        onSuccess: function (data) {
            setCurrentConversationId(data.id);
            setMessages(data.messages);
        },
        onError: function () {
            // Error handling?
            navigate('/connections/chats');
        },
    }), isLoading = _e.isLoading, chat = _e.data;
    (0, react_1.useEffect)(function () {
        if (!isLoading && chat && topBarRef.current) {
            setHeight(defaultHeight + topBarRef.current.clientHeight);
        }
    }, [isLoading, chat]);
    (0, react_1.useEffect)(function () {
        if (chat) {
            var hasNotification = typeof notifications.conversations[chat.id] !== 'undefined';
            if (hasNotification) {
                clearNotification('conversations', chat.id, chat.id);
            }
        }
    }, [clearNotification, notifications.conversations, chat]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(material_1.LinearProgress, {});
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ id: "chatWindow", sx: isSmallScreen ? __assign(__assign({}, ConnectionStyles_1.containerStyles.containerMobile), { height: "calc(100vh - ".concat(height, "px)") }) : ConnectionStyles_1.containerStyles.container }, { children: [currentConnection && ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ ref: topBarRef, sx: ConnectionStyles_1.containerStyles.topBar }, { children: [(0, jsx_runtime_1.jsx)(material_1.Avatar, { src: currentConnection.profile.profilePicture, alt: currentConnection.name }), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", variant: "h5", flexGrow: "1" }, { children: currentConnection.name })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", alignItems: "center", textAlign: "end", gap: 2, sx: { cursor: 'pointer', userSelect: 'none' }, onClick: function () { return setTab(tab === 0 ? 1 : 0); } }, { children: (0, jsx_runtime_1.jsx)(CurrentTab_1.default, { tab: tab }) }))] }))), tab === 0 ? (0, jsx_runtime_1.jsx)(MessageList_1.default, { messages: messages, chatId: chat === null || chat === void 0 ? void 0 : chat.id }) : (0, jsx_runtime_1.jsx)(SharedVacanciesList_1.default, { chatId: chat === null || chat === void 0 ? void 0 : chat.id })] })));
}
exports.default = Chat;
